(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kivevora-home-v2"] && !Shopify.designMode) return;
  try {
    
  function unlockKivevoraHomeScroll() {
    if (!document.querySelector('.kv-home')) return;
    document.documentElement.style.setProperty('height', 'auto', 'important');
    document.documentElement.style.setProperty('overflow-y', 'auto', 'important');
    document.body.style.setProperty('height', 'auto', 'important');
    document.body.style.setProperty('min-height', '100vh', 'important');
    document.body.style.setProperty('overflow-y', 'auto', 'important');
    document.body.style.setProperty('display', 'block', 'important');
    var main = document.querySelector('main.content-for-layout');
    if (main) main.style.setProperty('display', 'block', 'important');
  }

  unlockKivevoraHomeScroll();
  document.addEventListener('DOMContentLoaded', unlockKivevoraHomeScroll);
  window.addEventListener('load', unlockKivevoraHomeScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kivevora-home-v3"] && !Shopify.designMode) return;
  try {
    
  function unlockKivevoraHomeScroll() {
    if (!document.querySelector('.kv-home')) return;
    var main = document.querySelector('main.content-for-layout');
    var home = document.querySelector('.kv-home');
    var pageHeight = Math.max(
      window.innerHeight,
      main ? main.scrollHeight : 0,
      home ? home.scrollHeight + (home.getBoundingClientRect().top || 0) : 0
    );
    document.documentElement.style.setProperty('height', pageHeight + 'px', 'important');
    document.documentElement.style.setProperty('overflow-y', 'auto', 'important');
    document.body.style.setProperty('height', pageHeight + 'px', 'important');
    document.body.style.setProperty('min-height', pageHeight + 'px', 'important');
    document.body.style.setProperty('overflow-y', 'auto', 'important');
    document.body.style.setProperty('display', 'block', 'important');
    if (main) main.style.setProperty('display', 'block', 'important');
  }

  unlockKivevoraHomeScroll();
  document.addEventListener('DOMContentLoaded', unlockKivevoraHomeScroll);
  window.addEventListener('load', unlockKivevoraHomeScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
